import React, { Component, useState, useEffect } from 'react';
import Select from 'react-select';
import * as ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { debug } from 'util';
import axios from 'axios';
import Configdata from './Defaultdata';
import './home.css';
import Localdata from './Localdata';
import './cube.css';
import { tblrows,getmessage,sendpostnow,getptypebyid,getaply,wrongmsg } from './Dynamictable';
import Usersession from './Usersession';
export default class Viewsalesapply extends Component {

    constructor(props: any) {
   	super(props);
	this.state.name = "siikaa";
	
  	}
	
    state = {

	
        name: "SIIKAA",
       respdata: null,   
       url: "",
       tblheaders:[''],		
       tblrows: [{id:1, nm: 'c'}],	
       
       tblfiterdata: [{pusercode:'000', phone:'0000000000', trefer:0,auth:'Bronze',status:'Apply',id:'0'}]
 	
    };

    
   
    
	
   
  
    setserverurl() {
        debugger;
        const appurl = Configdata.srvurl;
       
        this.setState({ url: appurl });
    }
    componentDidMount() {
        debugger;
	
        const pid = localStorage.getItem("id");
        
        this.setserverurl();
        const ar = [{id:1, nm: 'c'},{id:2, nm: 'd'}]
	
	const cols = ["Code","Ph","Refs","Auth","Sts"];
        this.setState({ tblheaders: cols });
	this.setState({ tblrows: ar});
        const code = localStorage.getItem("id"); 
        this.getpostapply(code);

    }
 
 getpostapply(eid: any){
	 try {
          const url = "/getsalesapply?prd=" + eid +"";
	//alert(url);	
	axios.get(Configdata.srvurl + url)
            .then((response: any) => {
               
		const tdata = response.data;
             
		this.reducearray(tdata);
            })
            .catch((err: any) => {
                alert('Something went wrong');
                
            });

                
          }
        catch (e) {
            debugger;

        }

	
      	//e.preventDefault()


     }	

     reducearray(arr: any){
     let farr = [{}];
      if(arr){
	     if(arr.length > 0){
		for(let i =0;i< arr.length;i++){
                let v = {pusercode:'000', phone:'0000000000', trefer:'0',auth:'Brn',status:'Apply',id:0}
                let sts = "Apply";  
		let psts = "Bronze";
                 const rv = arr[i][0];
		 v["pusercode"] = rv["pusercode"];
		 v["phone"] = rv["phone"];
		 v["trefer"] = rv["trefers"];
		 const authid = rv["pid"];
		 v["auth"] = getptypebyid(authid);
		 const stsid = rv["aid"];

		 v["status"] = getaply(stsid);
		 v["id"] =  rv["dtlid"]

		 farr.push(v);
		 
		}
	    }
	 }
	if(farr.length > 1){
	 farr.shift();
	}
	else{
	farr.shift();
	getmessage('You have no posts','');
	}
	this.setState({ tblfiterdata: farr});
	
      }	

 saleexcapprove(e:any){
   const applyid = e.target.id;
   const ucode = localStorage.getItem("id"); 

   this.approvepostapply(ucode,applyid);	
   e.preventDefault()
 }   
approvepostapply(eid: any,id: any){
	 try {
                let url = Configdata.srvurl + '/approvesalexcutive';
		//if(this.iregctrlsvalidate('na')){
          	getmessage('On Process Please wait.....','');	
		
                const response = axios.post(url, {
    		procode: eid,
    		
    		aplid: id
              
  		}, {
    		    headers: {
      				'Content-Type': 'application/json'
    			      }
  			}
		);
	      
                if(response){
		 response.then((result:any) => {
		const usercd = result.data;
		if(usercd == "NA")
		getmessage('Somtghing wrong','');
		else{
		getmessage(usercd,'');
		this.getpostapply(eid);
		}
		
	        });		
              }
		
	   //}
          }
        catch (exp:any) {
           // debugger;
		wrongmsg();
        }

     };	

 render() {

   
     return (

         <form>
	<div className="per100" id="postmain">
	 <div className="postingouterdiv" style={{overflowX:'hidden',overflowY:'auto',height:'93vh'}}>
	  <div className="postingtablediv">

	    <table className="postingtable">
		
		<thead>
		   <tr>	
			{this.state.tblheaders.map((str,index)=>(
			<th className="comptd" style={{width:'20%'}}>{str}</th>
			))}
		   </tr>	
		</thead>

		
		<tbody>
			{this.state.tblfiterdata.map((row,index)=>(
		<tr>
			<td className="comptd" style={{width:'20%'}}>
			  <a href="#" onClick={e => this.saleexcapprove(e)} >
				<span id={row.id}>{row.pusercode}</span>
			   </a>
			</td>
			<td className="comptd" style={{width:'20%'}}><span>{row.phone}</span></td>
			<td className="comptd" style={{width:'20%'}}><span>{row.trefer}</span></td>
			<td className="comptd" style={{width:'20%'}}><span>{row.auth}</span></td>
			<td className="comptd" style={{width:'20%'}}><span>{row.status}</span></td>

		</tr>
			))}
		 </tbody>	
		
	   </table>
	 </div>		
	</div>
	
	</div>
   	</form>
    
   
      );
}
}

